import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconRocket } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { H2 } from '@ui';
import classNames from 'classnames';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { Rate } from '../../../../ui/rate';
import { TTopUpStatus } from '../../NewOutstandingView.helpers';

export const InterestOnlyExtensionApprovedAlert = ({
    topUpStatus,
    onClick,
    approvalAmount,
    interestRate,
    timeoutDate
}: {
    topUpStatus: TTopUpStatus;
    onClick: () => void;
    approvalAmount: number;
    interestRate: number;
    timeoutDate: string;
}) => {
    const renderDescription = () => {
        switch (topUpStatus) {
            case 'INTEREST_ONLY_EXTENSION_APPROVED':
                return (
                    <FormattedMessage
                        id="_.outstanding_view.interestOnlyExtenionDescription"
                        defaultMessage="You can extend your interest-only period by 3 months keeping your interest rate at {interestRate} per month before {timeoutDate}"
                        values={{
                            interestRate: <Rate value={interestRate} />,
                            timeoutDate: (
                                <FormattedDate
                                    value={timeoutDate}
                                    day="2-digit"
                                    month="short"
                                    year="numeric"
                                />
                            )
                        }}
                    />
                );
            case 'INTEREST_ONLY_EXTENSION_APPROVED_WITH_MORE_FUNDS':
                return (
                    <FormattedMessage
                        id="_.outstanding_view.interestOnlyExtenionWithFundsDescription"
                        defaultMessage="You can extend your interest-only period by 3 months and draw down up to {amount} with an interest rate of {interestRate} per month before {timeoutDate}"
                        values={{
                            amount: (
                                <FormattedCurrency value={approvalAmount} />
                            ),
                            interestRate: <Rate value={interestRate} />,
                            timeoutDate: (
                                <FormattedDate
                                    value={timeoutDate}
                                    day="2-digit"
                                    month="short"
                                    year="numeric"
                                />
                            )
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div
            data-testid="topup-approved-banner-redesign"
            className={classNames(
                'flex items-start gap-s rounded-m bg-gradient-to-t from-success-drk to-success-mid p-m min-sm:gap-l min-sm:p-l'
            )}
        >
            <IconRocket className="mt-xs size-xl shrink-0 fill-structure-100" />
            <div className="space-y-m">
                <div className="space-y-s min-sm:space-y-xs">
                    <H2 className="text-m font-bold text-structure-100">
                        <FormattedMessage
                            id="_.outstanding_view.topupApprovedTitle"
                            defaultMessage="You're approved!"
                        />
                    </H2>
                    <p
                        data-testid="approved-alert-description"
                        className="m-0 font-reg text-white"
                    >
                        {renderDescription()}
                    </p>
                </div>

                <Button variant="secondary-alt" onClick={onClick}>
                    <FormattedMessage
                        id="_.outstanding_view.interestOnlyExtendCta"
                        defaultMessage="Extend my interest-only period"
                    />
                </Button>
            </div>
        </div>
    );
};
